import React from "react";

const OurService = () => {
  return <h1>Our Services</h1>;
};

export default OurService;